import React from 'react';
import PropTypes from 'prop-types';
import Input from '@Components/Input';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import { possibleResults } from '../ForgotPasswordDialogConstants';

const spinnerId = 'resetPasswordForm';

function ForgotPasswordDialogContent({
  requestSent,
  email,
  setEmail,
  isLoading,
  result,
  isEmailValid,
  trackAdobeAnalyticsError,
}) {
  const trackAdobeAnalyticsFormError = () => {
    if (!email && !isLoading) {
      trackAdobeAnalyticsError('Incorrect email address', 'fe-');
    }
  };

  if (result) {
    return (
      <section className="forgot-password-dialog__result">
        {result === possibleResults.success && (
        <span className="success-message">
          A link to reset your password has been sent to your email address. Please check your inbox.
        </span>
        )}
        {result === possibleResults.emailInvalid && (
        <span className="error-message">
          Invalid email
        </span>
        )}
        {result === possibleResults.error && (
        <span className="error-message">
          Server error
        </span>
        )}
      </section>
    );
  }

  return (
    <>
      {isLoading && <SimpleSpinner id={spinnerId} />}
      <div className="forgot-password-dialog__text">
        Enter your email address below and we will send you an email with a link to create a new password
      </div>

      <Input
        clearButton={false}
        classNameInput="e2e-forgot-password-email-input"
        animatedPlaceholder
        placeholder="Your email address"
        value={email}
        onChange={setEmail}
        onBlur={trackAdobeAnalyticsFormError}
        disabled={isLoading}
        validationMessage={!isEmailValid && requestSent && 'Incorrect email address'}
      />
    </>
  );
}

ForgotPasswordDialogContent.propTypes = {
  requestSent: PropTypes.bool,
  email: PropTypes.string,
  setEmail: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  result: PropTypes.string,
  isEmailValid: PropTypes.bool,
  trackAdobeAnalyticsError: PropTypes.func.isRequired,
};

export default ForgotPasswordDialogContent;
